/*
    模块组件
    ChenYN

    说明
    主页底部切换栏

    版本
    1.0

    传参
        goodsData Object : 必填 商品信息
        type String : 非必填 商品类型 默认 shop
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <demo></demo>
*/
<template>
    <div class="good_card">
        <div class="good_main"><img :src="goodData.content.items?goodData.content.items[0].image:goodData.content" /></div>
        <div class="good_name van-ellipsis">{{goodData.name}}</div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import router from "@/router"
import { Button } from "vant"

export default defineComponent({
    name: 'GoodCard',
    components: { Button },
    props: {
        goodData: {
            type: Object
        },
    },
    setup(props) {
        const state = reactive({});
        const data = reactive({});
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
        }; //需要对外暴露的方法

        onMounted(() => {
        });

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./GoodCard.less";
</style>